import CommunityOverview from "@/views/community/Overview.vue";

export default [
  {
    path: "/communities",
    name: "communities",
    component: CommunityOverview,
    meta: {
      slug: "communities",
      title: "titles.communities_overview",
    },
  },

  {
    path: "/communities/overview",
    name: "communities-overview",
    component: CommunityOverview,
    meta: {
      slug: "communities",
      title: "titles.communities_overview",
    },
  },

  {
    path: "/communities/:id/overview",
    name: "community-overview",
    component: CommunityOverview,
    props: true,
    meta: {
      slug: "communities",
      title: "titles.communities_overview",
    },
  },
];
